import "./Actions.css";
import BlueSidebar from "../../components/BlueSidebar";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import Store, { Context } from "../../components/Store";
import { useContext, useState } from "react";
import { Context2 } from "../../components/Audio";
import ReactPlayer from "react-player/lazy";

import { UserContext } from "../../realm/user.context";
import { updateProfile, insertWellness, updateEmotionCount } from "../../realm/graphqlQueries";

const initialState = {
  action: "",
  emotion: "",
  date: "",
  helpful: false,
};

const Actions = (props) => {
  const { realmUser } = useContext(UserContext);
  const navigate = useNavigate();
  const [playing, setPlaying]= useContext(Context2);
  const [wellnessDataPoint, setWellnessDataPoint] = useContext(Context);
  const audio_url_prefix = props.user.user.voice?props.user.user.voice.replace(" ","_"):"english_female"
  async function createDoc(realmUser, wellnessDataPoint) {
    // Adding the wellness document
    wellnessDataPoint.date = new Date(wellnessDataPoint.date)
    const response = await insertWellness(wellnessDataPoint, props.user.user, realmUser);
    props.lSetWellnessId(response.insertOneWellness._id)
  }

  async function saveToDatabaseAndNav(action) {
    console.log(wellnessDataPoint)
    const temp = wellnessDataPoint;
    temp.action = action;
    temp.date = Date.now();
    setWellnessDataPoint(temp);
    createDoc(realmUser, wellnessDataPoint);
    navigate('/performaction')
  }

  const GreenActions = () => {
    const [otherText, setOtherText] = useState('');
    const [visible, setVisible] = useState(false);
    const handleChange = event => {
      setOtherText(event.target.value);
    };
    return(
    <div class="greenrow">
      <img
        onClick={() => saveToDatabaseAndNav("Move my body")}
        class="actions"
        src="../images/actions/Move my body.png"
        alt="loading..."
        loading="lazy"
      />
      <img
        onClick={() => saveToDatabaseAndNav("Smile big")}
        class="actions"
        src="../images/actions/Smile big.png"
        alt="loading..."
        loading="lazy"
      />
      <img
        onClick={() => saveToDatabaseAndNav("Stretch")}
        class="actions"
        src="../images/actions/Stretch.png"
        alt="loading..."
        loading="lazy"
      />
      <img
        onClick={() => saveToDatabaseAndNav("Be mindful. Be where my feet are")}
        class="actions"
        src="../images/actions/Be mindful. Be where my feet are.png"
        alt="loading..."
        loading="lazy"
      />
      <img
        onClick={() => saveToDatabaseAndNav("Help Others")}
        class="actions"
        src="../images/actions/Help Others.png"
        alt="loading..."
        loading="lazy"
      />
      <img
        onClick={() =>
          saveToDatabaseAndNav("Think of 3 things that I am grateful for")
        }
        class="actions"
          loading="lazy"
        src="../images/actions/Think of 3 things that I am grateful for.png"
        alt="loading..."
      />
      <img
        onClick={() => saveToDatabaseAndNav("Give someone a compliment")}
        class="actions"
        src="../images/actions/Give someone a compliment.png"
        alt="loading..."
        loading="lazy"
      />
      <img
        onClick={() => saveToDatabaseAndNav("Write in my journal")}
        class="actions"
        src="../images/actions/Write in my journal.png"
        alt="loading..."
        loading="lazy"
      />
      {visible === true ? (
        <div class="imgTextBoxRow">
          <img
            onClick={() => setVisible(false)}
            class="actions"
            src="../images/actions/Other.png"
            alt="loading..."
            loading="lazy"
          />
          <input
            type="text"
            placeholder="Type your wellness practice"
            value={otherText}
            onChange={handleChange}
            class="othertextbox"
          ></input>
          <button 
                  onClick={() => saveToDatabaseAndNav('Other: ' + otherText)}
          class="submitaction"
          style={{marginBottom:'18vh'}}

          >Submit</button>
        </div>
      ) : (
        <img
          onClick={() => setVisible(true)}
          class="actions"
          src="../images/actions/Other.png"
          alt="loading..."
          loading="lazy"
          style={{marginBottom:'18vh'}}
        />
      )}
    </div>
  );
      }
  const BlueActions = () => (
    <div class="bluerow" style={{}}>
      <img
        onClick={() =>
          saveToDatabaseAndNav("Imagine positive things in the future")
        }
        class="actions"
        src="../images/actions/Imagine positive things in the future.png"
        alt="loading..."
        loading="lazy"
      />
      <img
        onClick={() => saveToDatabaseAndNav("Laugh at something funny")}
        class="actions"
        src="../images/actions/Laugh at something funny.png"
        alt="loading..."
        loading="lazy"
      />
      <img
        onClick={() =>
          saveToDatabaseAndNav("Remember that difficult times pass")
        }
        class="actions"
        src="../images/actions/Remember that difficult times pass.png"
        alt="loading..."
        loading="lazy"
      />
      <img
        onClick={() =>
          saveToDatabaseAndNav("Remind myself of two good things in my life")
        }
        class="actions"
        src="../images/actions/Remind myself of two good things in my life.png"
        alt="loading..."
        loading="lazy"
      />
      <img
        onClick={() => saveToDatabaseAndNav("Tell myself something nice")}
        class="actions"
        src="../images/actions/Tell myself something nice.png"
        alt="loading..."
        loading="lazy"
      />
      <img
        onClick={() => saveToDatabaseAndNav("Get some sun in my eyes")}
        class="actions"
        src="../images/actions/Get some sun in my eyes.png"
        alt="loading..."
        loading="lazy"
      />
    </div>
  );
  const PurpleActions = () => (
    <div class="purplerow" style={{}}>
      <img
        onClick={() =>
          saveToDatabaseAndNav("Count to ten taking a deep breath each time")
        }
        class="actions"
        src="../images/actions/Count to ten taking a deep breath each time.png"
        alt="loading..."
        loading="lazy"
      />
      <img
        onClick={() => saveToDatabaseAndNav("Imagine a peaceful place")}
        class="actions"
        src="../images/actions/Imagine a peaceful place.png"
        alt="loading..."
        loading="lazy"
      />
      <img
        onClick={() => saveToDatabaseAndNav("Listen to music or read")}
        class="actions"
        src="../images/actions/Listen to music or read.png"
        alt="loading..."
        loading="lazy"
      />
      <img
        onClick={() =>
          saveToDatabaseAndNav("Politely move away from a distraction")
        }
        class="actions"
        src="../images/actions/Politely move away from a distraction.png"
        alt="loading..."
        loading="lazy"
      />
      <img
        onClick={() => saveToDatabaseAndNav("Squeeze my fist")}
        class="actions"
        src="../images/actions/Squeeze my fist.png"
        alt="loading..."
        loading="lazy"
      />
      <img
        onClick={() => saveToDatabaseAndNav("Use my growth mindset")}
        class="actions"
        src="../images/actions/Use my growth mindset.png"
        alt="loading..."
        loading="lazy"
      />
    </div>
  );
  function getColor() {
    const temp = wellnessDataPoint;
    const emotion = temp.emotion;
    if (emotion === "happy" || emotion === "grateful" || emotion === "calm")
      // return "#A5E2C6";
      return "green";
    else if (
      emotion === "stressed" ||
      emotion === "scared" ||
      emotion === "angry"
    )
      return "purple";
    // return "#DEC8F1";
    else if (emotion === "sad" || emotion === "tired" || emotion === "lonely")
      // return "#ADCDEA";
      return "blue";
  }

  return (
    <motion.div
      class="outeractions"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      {/* <BlueSidebar></BlueSidebar> */}
      <div class='reactplayer'>
        <ReactPlayer playing={playing} url={"audio/"+audio_url_prefix+"/actions.wav"} />
      </div>
      <div class="classandactions">
      <div class="seeandheartextrow">
          <img
            class="greennumber"
            src="../images/green3.png"
            alt="loading..."
            loading="lazy"
          />
          <h1 class="howdoifeel">&nbsp;Is there anything I NEED?</h1>
        </div>
        {getColor() == "green" && <GreenActions></GreenActions>}
        {getColor() == "purple" && (
          <div class="emotionscolumn">
            <PurpleActions />
            <GreenActions />
          </div>
        )}
        {getColor() == "blue" && (
          <div class="emotionscolumn">
            <BlueActions />
            <GreenActions />
          </div>
        )}
      </div>
    </motion.div>
  );
};

export default Actions;
